import FormBaseModel from '@cp-models/FormBaseModel';

export default class Contact extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'email': 'string',
            'main_phone': 'string',
            'cell_phone': 'string'
        }
    }
}
